import { persistentAtom } from "@nanostores/persistent"
import { useStore } from "@nanostores/react"
import { atom } from "nanostores"
import { type PreQualState, setPreQualState } from "./preQual"

const TOKEN_KEY = "token"

export const $authToken = persistentAtom<string | null>(TOKEN_KEY, null, {
  encode: (val: any) => val,
  decode: (val: string): string => val,
})

export const setAuthToken = (token: string | null) => {
  $authToken.set(token)
}

interface RedirectState {
  prequal?: PreQualState
}

const $redirectState = atom<RedirectState | null>(null)

export const setRedirectState = (state: string) => {
  const newRedirectState = JSON.parse(state) as RedirectState
  $redirectState.set(JSON.parse(state) as RedirectState)
  if (newRedirectState?.prequal) {
    setPreQualState(newRedirectState.prequal)
  }
}

export const clearRedirectState = () => {
  $redirectState.set(null)
}

export const useRedirectState = () => {
  const redirectState = useStore($redirectState)
  return redirectState
}
